import { createReducer, on } from '@ngrx/store';

import {
  searchFlexDatesMobileSuccessAction, searchFlexDatesAction, searchFlexDatesErrorAction
} from '@flight-results/store/actions/flights-results.actions';
import { FlexibleDatesMappedResult } from '@flight-results/entities/flexible.dates';

export const initialFlexibleDatesMappedState: FlexibleDatesMappedResult = {} as FlexibleDatesMappedResult;

export const flexDatesMappedReducer = createReducer(
  initialFlexibleDatesMappedState,
  on(searchFlexDatesAction, () => initialFlexibleDatesMappedState),
  on(searchFlexDatesMobileSuccessAction, (state, { flexDatesMappedResults }) => flexDatesMappedResults),
  on(searchFlexDatesErrorAction, () => initialFlexibleDatesMappedState)
);
